import { each } from 'lodash';
import EventBusEmitter from '@core/event-bus/EventBusEmitter';
import { KEYS } from './state';

async function initialize(context) {
  EventBusEmitter.on('alertsHistory:add', alerts => context.dispatch('addAlerts', alerts), 'alertsHistory');
  EventBusEmitter.on('alertsHistory:alertEnded', alert => context.dispatch('addAlerts', [alert]), 'alertsHistory');
}

async function addAlerts({ commit, getters }, alerts) {
  if (alerts) {
    each(alerts, (alert) => {
      const previousAlert = getters.getAlertState(alert);
      if (previousAlert) {
        if (
          previousAlert.showAlert !== alert.showAlert || previousAlert.message !== alert.message
        ) {
          commit('addAlert', alert);
        }
      } else if (alert.showAlert) {
        commit('addAlert', alert);
      }
    });
  }
}

async function clearAlerts({ commit }) {
  commit('clearAlerts');
}

async function showBadge({ commit }, show) {
  commit('showBadge', show);
}


/**
 * Search alerts
 * @param commit
 * @param payload {Object}
 * @param payload.searchTerm {String}
 * @return {Promise<void>}
 */
async function searchAlerts({ commit }, payload) {
  const { searchTerm } = payload;
  commit('setProp', { key: KEYS.SEARCH_TERM, value: searchTerm });
}

export default {
  addAlerts,
  clearAlerts,
  searchAlerts,
  showBadge,
  initialize,
};
